import { RouterProvider } from 'react-router';

import type { RuntimeEnv } from '@core/config/env';

import { ClerkNotConfigured } from './ClerkNotConfigured';
import { AppProviders } from './providers/AppProviders';
import { router } from './routes';

interface AppProps {
  env: RuntimeEnv;
}

/** The placeholder key shipped in public/env.js before a real Clerk app exists. */
const PLACEHOLDER_KEY_MARKER = 'placeholder';

export function App({ env }: AppProps) {
  // ClerkProvider throws on an invalid key, which blanks the page with only a console
  // error to go on. Checking first turns that into instructions.
  if (env.CLERK_PUBLISHABLE_KEY.includes(PLACEHOLDER_KEY_MARKER)) {
    return <ClerkNotConfigured />;
  }

  return (
    <AppProviders env={env}>
      <RouterProvider router={router} />
    </AppProviders>
  );
}
